import { render } from "./CreatePatientCard.vue?vue&type=template&id=7d7c79b2&ts=true"
import script from "./CreatePatientCard.vue?vue&type=script&lang=ts"
export * from "./CreatePatientCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Welcome/CreatePatientCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d7c79b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d7c79b2', __exports__)) {
    api.reload('7d7c79b2', __exports__)
  }
  
  module.hot.accept("./CreatePatientCard.vue?vue&type=template&id=7d7c79b2&ts=true", () => {
    api.rerender('7d7c79b2', render)
  })

}


export default __exports__